import SettingsComponent from "../../components/Settings";

const Settings = () => {
  return <SettingsComponent />;
};

export default Settings;
